import React from 'react';

const Blogs = () => {
    return (
      <div style={{ background: '#2c323f' }} >
          <div className='text-center h-96 flex justify-center items-center font-bold  h-[44rem]'>
          <p className='text-3xl text-orange-300'>Blog is Cooking</p>
        </div>
      </div>
    );
};
export default Blogs;